import { Carousel } from '@/components';
import { Content } from '@prismicio/client';
import { PrismicNextImage } from '@prismicio/next';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';

/**
 * Props for `Leaders`.
 */
export type LeadersProps = SliceComponentProps<Content.LeadersSlice>;

/**
 * Component for "Leaders" Slices.
 */
const Leaders = ({ slice }: LeadersProps): JSX.Element => {
  const renderLeaders = () => {
    return slice.primary.leaders.map((leader, index) => {
      return (
        <div
          key={`leader_${index.toString()}`}
          className="group xl:min-w-[237px] xl:max-w-[400px] xl:min-h-[505px] h-[630px] relative flex jus"
        >
          <div
            className={`xl:h-full shrink grow h-[560px] xl:w-full max-w-[356px] overflow-hidden flex items-end justify-center rounded-[20px] mx-auto ${leader.background}`}
          >
            <PrismicNextImage
              field={leader.picture}
              className="xl:h-full object-cover"
            />
          </div>
          <div className="py-12 pl-8 h-[142px] max-w-[220px] w-[90%] opacity-0 transform translate-y-[80%] group-hover:opacity-100 group-hover:translate-y-[-20%] xl:group-hover:translate-y-[30%] absolute bottom-1 left-1/2 -translate-x-1/2 transition-transform duration-450 bg-white rounded-[20px] overflow-hidden text-black z-10 bg-white-gradient">
            <div className="font-semibold">{leader.name}</div>
            <div>{leader.title}</div>
          </div>
        </div>
      );
    });
  };

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="xl:py-28 xl:px-16 px-5 py-16 text-white max-w-screen-2xl mx-auto"
    >
      <div className="flex flex-col gap-20">
        <div className="text-center gap-6 flex flex-col">
          <PrismicRichText field={slice.primary.title} />
          <PrismicRichText field={slice.primary.description} />
        </div>
        <div className="hidden xl:flex justify-center gap-8">
          {renderLeaders()}
        </div>
        <div className="xl:hidden">
          <Carousel showDots={false}>{renderLeaders()}</Carousel>
        </div>
      </div>
    </section>
  );
};

export default Leaders;
